import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App'
import { UserProvider } from './components/context/User';
import { NotificationProvider } from './components/context/Notification';
import { CalcsProvider } from './components/context/Calcs';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <UserProvider>
      <NotificationProvider>
        <CalcsProvider>
          <App />
        </CalcsProvider>
      </NotificationProvider>
    </UserProvider>
  </BrowserRouter>
);